import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { z } from 'zod'
import { asyncJobFilterShape, asyncJobShape } from './models'

const cancel = createCustomServiceCall({
  inputShape: z.string().uuid(),
  outputShape: asyncJobShape,
  cb: async ({ client, slashEndingBaseUri, input, utils: { fromApi } }) => {
    const response = await client.post(`${slashEndingBaseUri}${input}/cancel/`)
    return fromApi(response.data)
  },
})

export const asyncJobApi = createApi({
  client: axiosInstance,
  baseUri: '/jobs/',
  models: {
    entity: asyncJobShape,
    extraFilters: asyncJobFilterShape,
  },
  customCalls: {
    cancel,
  },
})
